import { render, staticRenderFns } from "./EditImageField.vue?vue&type=template&id=b92e712c&scoped=true"
import script from "./EditImageField.vue?vue&type=script&setup=true&lang=js"
export * from "./EditImageField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditImageField.vue?vue&type=style&index=0&id=b92e712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92e712c",
  null
  
)

export default component.exports